import { useTranslation } from "react-i18next";
import ListGroup, { ListGroupItem } from "./controls/ListGroup";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";

import LinkButton from "./controls/LinkButton";
import { MedicionCaudalMasicoSchema } from "../data/MedicionCaudalMasicoSchema";
import { Formik } from "formik";
import TypeaheadField from "./controls/TypeaheadField";
import { isInvalid } from "../utils/forms";
import AmmountField from "./controls/AmmountField";
import TrashIcon from "./icon/TrashIcon";
import PlusIcon from "./icon/PlusIcon";
import { decode } from "he";

export function CaudalMasicoForm({
  value,
  append,
  remove,
  contaminantes,
  disabled,
}) {
  const { t } = useTranslation();
  const handleContaminanteChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleCantidadChange = (form) => (event) => {
    form.handleChange(event);
  };
  return (
    <ListGroup>
      <ListGroupItem>
        <Grid>
          <Row>
            <Col lg={1}>#</Col>
            <Col lg={6}>{t("medicion.contaminante")}</Col>
            <Col lg={4}>{t("medicion.cantidad")}</Col>
          </Row>
        </Grid>
      </ListGroupItem>
      {value.map((medicion, index) => (
        <ListGroupItem key={medicion.contaminante.codigo}>
          <Grid>
            <Row>
              <Col lg={1}>
                <Label>{index + 1}</Label>
              </Col>
              <Col lg={6}>
                <Label>{medicion?.contaminante.nombre}</Label>
              </Col>
              <Col lg={4}>
                <Label>
                  {medicion?.cantidad.magnitud}&nbsp;
                  {decode(medicion?.cantidad?.unidad?.html)}
                </Label>
              </Col>
              <Col lg={1}>
                <LinkButton
                  sm
                  style={{ margin: 0, fontSize: "16px" }}
                  onClick={(event) => {
                    event.preventDefault();
                    remove(index);
                  }}
                  disabled={disabled}
                >
                  <TrashIcon />
                </LinkButton>
              </Col>
            </Row>
          </Grid>
        </ListGroupItem>
      ))}
      <ListGroupItem>
        <Formik
          initialValues={MedicionCaudalMasicoSchema.cast(undefined, {
            assert: false,
          })}
          validationSchema={MedicionCaudalMasicoSchema}
          onSubmit={(values, { resetForm }) => {
            append(values);
            resetForm({
              values: MedicionCaudalMasicoSchema.cast(undefined, {
                assert: false,
              }),
            });
          }}
        >
          {(form) => (
            <Grid>
              <Row>
                <Col lg={1}>
                  <Label>*</Label>
                </Col>
                <Col lg={6}>
                  <TypeaheadField
                    id="ducto_caudalMasico_medicion_contaminante"
                    name="contaminante"
                    value={form.values?.contaminante}
                    onChange={handleContaminanteChange(form)}
                    options={contaminantes}
                    labelAttr="nombre"
                    valueAttr="codigo"
                    emptyLabel="..."
                    style={{ margin: 0 }}
                    isInvalid={isInvalid("contaminante", form)}
                    error={t(form.errors.contaminante)}
                    disabled={disabled}
                  />
                </Col>
                <Col lg={4}>
                  <AmmountField
                    id="ducto_caudalMasico_medicion_cantidad"
                    name="cantidad"
                    value={form.values?.cantidad}
                    onChange={handleCantidadChange(form)}
                    unit={form.values?.contaminante?.unidad}
                    style={{ margin: 0 }}
                    isInvalid={isInvalid("cantidad", form)}
                    error={t(form.errors.cantidad)}
                    disabled={disabled || !form.values?.contaminante}
                  />
                </Col>
                <Col lg={1}>
                  <LinkButton
                    sm
                    style={{ margin: 0, fontSize: "16px" }}
                    onClick={(event) => {
                      event.preventDefault();
                      form.submitForm();
                    }}
                    disabled={disabled}
                  >
                    <PlusIcon />
                  </LinkButton>
                </Col>
              </Row>
            </Grid>
          )}
        </Formik>
      </ListGroupItem>
    </ListGroup>
  );
}
